import React from 'react';
import { Box, Stack, Skeleton, Card, Container, Divider } from '@mui/material';

export default function GlobalSkeleton({ type = "default" }) {
  // A soft, theme-matching color for the skeleton waves
  const skelColor = 'rgba(58, 44, 35, 0.06)'; 

  // =====================================
  // 1. MENU GRID SKELETON
  // =====================================
  if (type === "menu") {
    return (
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1.5, p: 2 }}>
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Card key={i} elevation={0} sx={{ borderRadius: "20px", p: 1, border: '1px solid #ECE5DA', bgcolor: '#FFFFFF' }}>
            <Skeleton variant="rectangular" height={100} sx={{ borderRadius: "15px", bgcolor: skelColor }} />
            <Skeleton variant="text" width="80%" height={24} sx={{ mt: 1, bgcolor: skelColor }} />
            <Skeleton variant="text" width="40%" height={16} sx={{ mb: 1, bgcolor: skelColor }} />
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mt: 1 }}>
              <Box sx={{ width: '50%' }}>
                <Skeleton variant="text" width="60%" height={14} sx={{ bgcolor: skelColor }} />
                <Skeleton variant="text" width="80%" height={24} sx={{ bgcolor: skelColor }} />
              </Box>
              <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: '12px', bgcolor: skelColor }} />
            </Box>
          </Card>
        ))}
      </Box>
    );
  }

  // =====================================
  // 2. LIST SKELETON (Orders, Cart)
  // =====================================
  if (type === "list") {
    return (
      <Container maxWidth="md" sx={{ px: 2 }}>
        <Stack spacing={2}>
          {[1, 2, 3, 4].map((i) => (
            <Card key={i} elevation={0} sx={{ borderRadius: '24px', p: 2, border: '1px solid #ECE5DA', bgcolor: '#FFFFFF' }}>
              <Stack direction="row" spacing={2} sx={{ mb: 1.5 }} alignItems="center">
                <Skeleton variant="rounded" width={70} height={70} sx={{ bgcolor: skelColor, borderRadius: '16px' }} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="60%" height={28} sx={{ bgcolor: skelColor }} />
                  <Skeleton variant="text" width="30%" height={20} sx={{ bgcolor: skelColor }} />
                </Box>
              </Stack>
              <Divider sx={{ my: 1.5, borderStyle: 'dashed' }} />
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Skeleton variant="text" width="25%" height={24} sx={{ bgcolor: skelColor }} />
                <Skeleton variant="rectangular" width={85} height={32} sx={{ borderRadius: '16px', bgcolor: skelColor }} />
              </Stack>
            </Card>
          ))}
        </Stack>
      </Container>
    );
  }

  // =====================================
  // 3. PROFILE / FORM SKELETON
  // =====================================
  if (type === "profile") {
    return (
      <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Skeleton variant="circular" width={100} height={100} sx={{ mb: 4, bgcolor: skelColor }} />
        <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: '12px', mb: 2, bgcolor: skelColor }} />
        <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: '12px', mb: 2, bgcolor: skelColor }} />
        <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: '12px', mb: 4, bgcolor: skelColor }} />
        <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: '16px', bgcolor: skelColor }} />
      </Box>
    );
  }

  // =====================================
  // 4. DEFAULT FALLBACK
  // =====================================
  return (
    <Box sx={{ p: 2 }}>
      <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: '24px', mb: 2, bgcolor: skelColor }} />
      <Skeleton variant="text" width="70%" height={30} sx={{ mb: 1, bgcolor: skelColor }} />
      <Skeleton variant="text" width="40%" height={30} sx={{ bgcolor: skelColor }} />
    </Box>
  );
}